function WidgetComponent(item) {
	this.i = Number(item.seq);
	this.x = Number(item.x);
	this.y = Number(item.y);
	this.minH = Number(item.minH);
	this.mimW = Number(item.minW);
	this.h = Math.max(item.height, item.minH);
	this.w = Math.max(item.width, item.minW);
	this.parameter = JSON.parse(item.parameter);
	if (this.parameter) {
		this.para = Object.assign(this.parameter, JSON.parse(item.para || '{}'));
	} else {
		this.para = null;
	}
	this.isResizable = item.resizeYn === 'Y';
	this.widgetKey = item.widgetKey;
	this.widgetTitle = item.widgetTitle;
	this.useYn = item.useYn;
	// console.log('item -> WidgetComponent', item, this);
	return this;
}

WidgetComponent.prototype.equals = function (item) {
	return (
		this.x === item.x &&
		this.y === item.y &&
		this.w === item.w &&
		this.h === item.h &&
		this.i === item.i &&
		this.widgetTitle === item.widgetTitle
	);
};

export default WidgetComponent;
export { WidgetComponent };
